import React, { forwardRef, useRef, useImperativeHandle, useContext, useLayoutEffect, useState, useMemo, useReducer, useEffect } from 'react';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var DefaultRowRenderer = forwardRef(function (props, ref) {
  return React.createElement("tr", _extends({}, props, {
    ref: ref
  }));
});
var DefaultCellRenderer = forwardRef(function (_ref, ref) {
  var columns = _ref.columns,
      index = _ref.index,
      rowIndex = _ref.rowIndex,
      props = _objectWithoutProperties(_ref, ["columns", "index", "rowIndex"]);

  return React.createElement("td", _extends({}, props, {
    ref: ref
  }));
});
var DefaultDataCellRenderer = forwardRef(function (_ref2, ref) {
  var header = _ref2.header,
      name = _ref2.name,
      Cell = _ref2.cell,
      data = _ref2.data,
      props = _objectWithoutProperties(_ref2, ["header", "name", "cell", "data"]);

  return Cell ? React.createElement(Cell, _extends({
    data: data,
    ref: ref
  }, props)) : React.createElement("span", {
    ref: ref
  }, data[name]);
});

var DefaultHeaderCellContentRenderer = function DefaultHeaderCellContentRenderer(_ref3) {
  var Header = _ref3.header,
      name = _ref3.name,
      cell = _ref3.cell,
      tableProps = _ref3.tableProps,
      children = _ref3.children;
  return React.createElement(React.Fragment, null, Header ? React.createElement(Header, _extends({}, tableProps, {
    name: name,
    cell: cell
  })) : name || null, children);
};

var DefaultHeaderCellRenderer = forwardRef(function (_ref4, ref) {
  var _ref4$headerCellConte = _ref4.headerCellContentRenderer,
      HeaderCell = _ref4$headerCellConte === void 0 ? DefaultHeaderCellContentRenderer : _ref4$headerCellConte,
      header = _ref4.header,
      name = _ref4.name,
      cell = _ref4.cell,
      tableProps = _ref4.tableProps,
      children = _ref4.children,
      props = _objectWithoutProperties(_ref4, ["headerCellContentRenderer", "header", "name", "cell", "tableProps", "children"]);

  return React.createElement("th", _extends({
    ref: ref
  }, props), React.createElement(HeaderCell, {
    tableProps: tableProps,
    name: name,
    cell: cell,
    header: header
  }), children);
});
var DefaultHeaderRenderer = forwardRef(function (_ref5, ref) {
  var columns = _ref5.columns,
      headerCellContentRenderer = _ref5.headerCellContentRenderer,
      _ref5$headerCellRende = _ref5.headerCellRenderer,
      Cell = _ref5$headerCellRende === void 0 ? DefaultHeaderCellRenderer : _ref5$headerCellRende,
      tableProps = _ref5.tableProps,
      _ref5$rowRenderer = _ref5.rowRenderer,
      Row = _ref5$rowRenderer === void 0 ? DefaultRowRenderer : _ref5$rowRenderer,
      props = _objectWithoutProperties(_ref5, ["columns", "headerCellContentRenderer", "headerCellRenderer", "tableProps", "rowRenderer"]);

  return React.createElement("thead", _extends({
    ref: ref
  }, props), React.createElement(Row, null, columns.map(function (props, i) {
    return React.createElement(Cell, _extends({
      key: i,
      tableProps: tableProps,
      headerCellContentRenderer: headerCellContentRenderer,
      index: i
    }, props));
  })));
});
var DefaultDataRowRenderer = forwardRef(function (_ref6, ref) {
  var data = _ref6.data,
      columns = _ref6.columns,
      index = _ref6.index,
      _ref6$cellRenderer = _ref6.cellRenderer,
      Cell = _ref6$cellRenderer === void 0 ? DefaultCellRenderer : _ref6$cellRenderer,
      _ref6$dataCellRendere = _ref6.dataCellRenderer,
      DataCell = _ref6$dataCellRendere === void 0 ? DefaultDataCellRenderer : _ref6$dataCellRendere,
      tableProps = _ref6.tableProps,
      _ref6$rowRenderer = _ref6.rowRenderer,
      Row = _ref6$rowRenderer === void 0 ? DefaultRowRenderer : _ref6$rowRenderer,
      props = _objectWithoutProperties(_ref6, ["data", "columns", "index", "cellRenderer", "dataCellRenderer", "tableProps", "rowRenderer"]);

  return React.createElement(Row, _extends({}, props, {
    ref: ref
  }), columns.map(function (columnProps, i) {
    return React.createElement(Cell, {
      key: i,
      columns: columns,
      index: i,
      rowIndex: index
    }, React.createElement(DataCell, _extends({}, columnProps, {
      data: data,
      index: i,
      rowIndex: index
    }, tableProps)));
  }));
});

var table = function table() {
  var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref7$rowRenderer = _ref7.rowRenderer,
      Row = _ref7$rowRenderer === void 0 ? DefaultRowRenderer : _ref7$rowRenderer,
      _ref7$cellRenderer = _ref7.cellRenderer,
      Cell = _ref7$cellRenderer === void 0 ? DefaultCellRenderer : _ref7$cellRenderer,
      _ref7$dataRowRenderer = _ref7.dataRowRenderer,
      DataRow = _ref7$dataRowRenderer === void 0 ? DefaultDataRowRenderer : _ref7$dataRowRenderer,
      _ref7$dataCellRendere = _ref7.dataCellRenderer,
      dataCellRenderer = _ref7$dataCellRendere === void 0 ? DefaultDataCellRenderer : _ref7$dataCellRendere,
      _ref7$headerCellRende = _ref7.headerCellRenderer,
      headerCellRenderer = _ref7$headerCellRende === void 0 ? DefaultHeaderCellRenderer : _ref7$headerCellRende,
      _ref7$headerCellConte = _ref7.headerCellContentRenderer,
      headerCellContentRenderer = _ref7$headerCellConte === void 0 ? DefaultHeaderCellContentRenderer : _ref7$headerCellConte,
      _ref7$headerRenderer = _ref7.headerRenderer,
      Header = _ref7$headerRenderer === void 0 ? DefaultHeaderRenderer : _ref7$headerRenderer;

  return forwardRef(function (_ref8, ref) {
    var children = _ref8.children,
        _ref8$data = _ref8.data,
        data = _ref8$data === void 0 ? [] : _ref8$data,
        _ref8$columns = _ref8.columns,
        columns = _ref8$columns === void 0 ? [] : _ref8$columns,
        _ref8$style = _ref8.style,
        style = _ref8$style === void 0 ? {} : _ref8$style,
        className = _ref8.className,
        props = _objectWithoutProperties(_ref8, ["children", "data", "columns", "style", "className"]);

    var tableRef = useRef();
    var headRef = useRef();
    useImperativeHandle(ref, function () {
      return {
        table: tableRef,
        head: headRef
      };
    });
    return React.createElement("table", {
      ref: tableRef,
      style: style,
      className: className,
      cellSpacing: 0,
      cellPadding: 0
    }, React.createElement("colgroup", null, columns.map(function (_, i) {
      return React.createElement("col", {
        key: i
      });
    })), React.createElement(Header, {
      ref: headRef,
      columns: columns,
      headerCellRenderer: headerCellRenderer,
      headerCellContentRenderer: headerCellContentRenderer,
      tableProps: props,
      rowRenderer: Row
    }), React.createElement("tfoot", null, children ? React.createElement(Row, {
      className: "additional-row"
    }, React.createElement(Cell, {
      colSpan: columns.length
    }, children)) : null), React.createElement("tbody", null, data.map(function (data, i) {
      return React.createElement(DataRow, {
        data: data,
        key: i,
        columns: columns,
        index: i,
        cellRenderer: Cell,
        dataCellRenderer: dataCellRenderer,
        tableProps: props,
        rowRenderer: Row
      });
    })));
  });
};

var composeDecorators = function composeDecorators() {
  for (var _len = arguments.length, hocFactories = new Array(_len), _key = 0; _key < _len; _key++) {
    hocFactories[_key] = arguments[_key];
  }

  return function () {
    var tableHoc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : table;
    var config = arguments.length > 1 ? arguments[1] : undefined;
    return hocFactories.reverse().reduce(function (r, h) {
      return h(r);
    }, tableHoc)(config);
  };
};

var EmptyRowContext = React.createContext({
  isEmpty: function isEmpty() {
    return false;
  },
  emptyRowContentRenderer: function emptyRowContentRenderer() {
    return null;
  },
  classNameFactory: function classNameFactory() {
    return 'empty-row';
  }
});
/**
 * Table dataRowRenderer decorator HoC.
 * 
 * @param {*} Row - dataRowRenderer
 */

var rowEnhancer = function rowEnhancer() {
  var DataRow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DefaultDataRowRenderer;
  var Row = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DefaultRowRenderer;

  var EmptyRowRenderer = function EmptyRowRenderer(props) {
    var _useContext = useContext(EmptyRowContext),
        isEmpty = _useContext.isEmpty,
        Component = _useContext.Component,
        classNameFactory = _useContext.classNameFactory;

    return Component != null && isEmpty(props) ? React.createElement(Row, {
      className: classNameFactory(props)
    }, React.createElement("td", {
      colSpan: props.columns.length
    }, React.createElement(Component, props))) : React.createElement(DataRow, props);
  };

  return EmptyRowRenderer;
};
/**
 * HoC that injects EmptyRowContext into a Table.
 * 
 * Injects the context.
 * Overrides row renderer to inject Component into the table.
 * 
 * @param {*} isEmpty
 * @param {*} Component
 */


var withEmptyRow = function withEmptyRow() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$isEmpty = _ref.isEmpty,
      isEmpty = _ref$isEmpty === void 0 ? function (_ref2) {
    var data = _ref2.data;
    return false;
  } : _ref$isEmpty,
      _ref$Component = _ref.Component,
      Component = _ref$Component === void 0 ? function () {
    return null;
  } : _ref$Component,
      _ref$classNameFactory = _ref.classNameFactory,
      classNameFactory = _ref$classNameFactory === void 0 ? function (dataRowProps) {
    return 'empty-row';
  } : _ref$classNameFactory;

  return function () {
    var tableFactory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : table;
    return function (_ref3) {
      var dataRowRenderer = _ref3.dataRowRenderer,
          rowRenderer = _ref3.rowRenderer,
          options = _objectWithoutProperties(_ref3, ["dataRowRenderer", "rowRenderer"]);

      var Table = tableFactory(_objectSpread2({
        dataRowRenderer: rowEnhancer(dataRowRenderer, rowRenderer),
        rowRenderer: rowRenderer
      }, options));
      return forwardRef(function (props, ref) {
        return React.createElement(EmptyRowContext.Provider, {
          value: {
            isEmpty: isEmpty,
            Component: Component,
            classNameFactory: classNameFactory
          }
        }, React.createElement(Table, _extends({
          ref: ref
        }, props)));
      });
    };
  };
};

var matchesMaxWidth = function matchesMaxWidth(width) {
  return window.matchMedia("(max-width: ".concat(width, "px)")).matches;
};
/**
 * React hook to execute a callback function on window match size
 * 
 * @param {*} callback - 
 */


var useMediaMaxWidth = function useMediaMaxWidth(callback) {
  var maxWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
  useLayoutEffect(function () {
    var listener = function listener() {
      callback(matchesMaxWidth(maxWidth));
    };

    window.addEventListener('resize', listener);
    return function () {
      window.removeEventListener('resize', listener);
    };
  });
  return matchesMaxWidth(maxWidth);
};
/**
 * Table dataCellRenderer decorator HoC.
 * 
 * @param {*} Cell - dataCellRenderer
 * @param {*} Component - colname component
 */


var withColname = function withColname() {
  var Cell = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DefaultDataCellRenderer;
  var Component = arguments.length > 1 ? arguments[1] : undefined;
  var WithAdaptiveColname = forwardRef(function (_ref, ref) {
    var header = _ref.header,
        name = _ref.name,
        _ref$removeAdaptiveCo = _ref.removeAdaptiveColname,
        removeAdaptiveColname = _ref$removeAdaptiveCo === void 0 ? false : _ref$removeAdaptiveCo,
        hideFullSize = _ref.hideFullSize,
        hideAdaptive = _ref.hideAdaptive,
        props = _objectWithoutProperties(_ref, ["header", "name", "removeAdaptiveColname", "hideFullSize", "hideAdaptive"]);

    var _useContext = useContext(AdaptiveContext),
        isAdaptive = _useContext.isAdaptive;

    return React.createElement(React.Fragment, null, isAdaptive && !removeAdaptiveColname ? React.createElement(Component, _extends({
      header: header,
      name: name
    }, props)) : null, React.createElement(Cell, _extends({
      header: header,
      name: name,
      ref: ref
    }, props)));
  });
  return WithAdaptiveColname;
};
/**
 * Table headerCellRenderer decorator HoC.
 * Removes removeOverflowWrapper property and stores it on context.
 * 
 * @param {*} Cell 
 */


var decorateHeaderCellRenderer = function decorateHeaderCellRenderer() {
  var Cell = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DefaultHeaderCellRenderer;
  return forwardRef(function (_ref2, ref) {
    var removeAdaptiveColname = _ref2.removeAdaptiveColname,
        hideFullSize = _ref2.hideFullSize,
        hideAdaptive = _ref2.hideAdaptive,
        props = _objectWithoutProperties(_ref2, ["removeAdaptiveColname", "hideFullSize", "hideAdaptive"]);

    var _useContext2 = useContext(AdaptiveContext),
        isAdaptive = _useContext2.isAdaptive;

    if (isAdaptive && hideAdaptive || !isAdaptive && hideFullSize) {
      return null;
    }

    return React.createElement(Cell, _extends({
      ref: ref
    }, props));
  });
};

var DefaultAdaptiveComponent = function DefaultAdaptiveComponent(_ref3) {
  var Header = _ref3.header,
      name = _ref3.name,
      onClick = _ref3.onClick,
      props = _objectWithoutProperties(_ref3, ["header", "name", "onClick"]);

  return React.createElement("span", {
    className: "adaptive-col-name"
  }, Header ? React.createElement(Header, _extends({}, props, {
    name: name,
    disabled: true
  })) : name || null);
};

var AdaptiveContext = React.createContext({
  isAdaptive: false
});

var withAdaptive = function withAdaptive() {
  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref4$Component = _ref4.Component,
      Component = _ref4$Component === void 0 ? DefaultAdaptiveComponent : _ref4$Component,
      _ref4$width = _ref4.width,
      width = _ref4$width === void 0 ? 940 : _ref4$width;

  return function () {
    var tableFactory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : table;
    return function () {
      var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          dataCellRenderer = _ref5.dataCellRenderer,
          headerCellRenderer = _ref5.headerCellRenderer,
          options = _objectWithoutProperties(_ref5, ["dataCellRenderer", "headerCellRenderer"]);

      var Table = tableFactory(_objectSpread2({
        dataCellRenderer: withColname(dataCellRenderer, Component),
        headerCellRenderer: decorateHeaderCellRenderer(headerCellRenderer)
      }, options));
      return forwardRef(function (_ref6, ref) {
        var className = _ref6.className,
            columns = _ref6.columns,
            props = _objectWithoutProperties(_ref6, ["className", "columns"]);

        var isAdaptiveByDefault = useMediaMaxWidth(function (matches) {
          if (matches !== isAdaptive) changeAdaptive(matches);
        }, width);

        var _useState = useState(isAdaptiveByDefault),
            _useState2 = _slicedToArray(_useState, 2),
            isAdaptive = _useState2[0],
            changeAdaptive = _useState2[1];

        var classNames = [];
        if (className != null) classNames.push(className);
        if (isAdaptive) classNames.push('adaptive-table');
        var filteredColumns = useMemo(function () {
          return columns.filter(function (_ref7) {
            var hideAdaptive = _ref7.hideAdaptive,
                hideFullSize = _ref7.hideFullSize;
            return isAdaptive && !hideAdaptive || !isAdaptive && !hideFullSize;
          });
        }, [isAdaptive]);
        return React.createElement(AdaptiveContext.Provider, {
          value: {
            isAdaptive: isAdaptive
          }
        }, React.createElement(Table, _extends({
          ref: ref,
          columns: filteredColumns,
          className: classNames.length > 0 ? classNames.join(' ') : undefined
        }, props)));
      });
    };
  };
};

var cloneStyles = function cloneStyles(node, dest) // called for each dest node
{
  var recursively = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var prop = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'cssText';
  var selector = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "*";
  var callback = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : function (dest, node) {};

  if (node.matches(selector)) {
    dest.style[prop] = getComputedStyle(node)[prop];
    callback(dest, node);
  }

  if (recursively) {
    var nodeChildren = node.querySelectorAll(selector);

    if (nodeChildren.length) {
      var destChildren = dest.querySelectorAll(selector);

      for (var i = 0, length = nodeChildren.length; i < length; i++) {
        cloneStyles(nodeChildren[i], destChildren[i], true, prop, selector, callback);
      }
    }
  }
};
/**
 * An iframe watcher of for element resize
 * Parent element should have position: relative
 * 
 * @param {*} - {onResize}
 */


var ResizeTrigger = function ResizeTrigger(_ref) {
  var onResize = _ref.onResize;
  var ref = useRef();
  useLayoutEffect(function () {
    ref.current.contentWindow.addEventListener('resize', onResize);
    return function () {
      ref.current.contentWindow.removeEventListener('resize', onResize);
    };
  });
  return React.createElement("iframe", {
    width: "100%",
    height: "100%",
    style: {
      position: 'absolute',
      top: 0,
      left: 0
    },
    ref: ref
  });
};

var addResizeTrigger = function addResizeTrigger() {
  var Cell = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DefaultHeaderCellRenderer;
  return forwardRef(function (_ref2, ref) {
    var children = _ref2.children,
        props = _objectWithoutProperties(_ref2, ["children"]);

    var _useContext = useContext(Context),
        layout = _useContext.layout;

    return React.createElement(Cell, _extends({}, props, {
      children: children,
      ref: ref
    }), React.createElement(ResizeTrigger, {
      onResize: layout
    }));
  });
};

var Context = React.createContext({
  layout: function layout() {}
});
/**
 * HoC factory to generate a table with fixed header.
 * 
 * Wraps the Table with multiple wrappers to make header fixed.
 * Utilizes useLayoutEffect and the monitorFactory to sync headers styles.
 * 
 * Adds scrollable container to the table generated ref.
 * 
 * !IMPORTANT!
 * Since this decorator is creating multiple tables it
 * should be before any other wrappers that use context provider.
 * 
 * @param {*} TableComponent 
 * @param {*} monitorFactory 
 */

var withFixedHeader = function withFixedHeader() {
  var tableFactory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : table;
  return function () {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref3$headerCellRende = _ref3.headerCellRenderer,
        headerCellRenderer = _ref3$headerCellRende === void 0 ? DefaultHeaderCellRenderer : _ref3$headerCellRende,
        options = _objectWithoutProperties(_ref3, ["headerCellRenderer"]);

    var Table = tableFactory(_objectSpread2({
      headerCellRenderer: addResizeTrigger(headerCellRenderer)
    }, options));
    var FakeTable = tableFactory(_objectSpread2({
      headerCellRenderer: headerCellRenderer
    }, options));
    return forwardRef(function (_ref4, ref) {
      var children = _ref4.children,
          data = _ref4.data,
          onScroll = _ref4.onScroll,
          props = _objectWithoutProperties(_ref4, ["children", "data", "onScroll"]);

      var tableRef = useRef();
      var clone = useRef();
      var scrollContainer = useRef();
      useImperativeHandle(ref, function () {
        return {
          table: tableRef.current.table,
          scrollContainer: scrollContainer.current,
          head: tableRef.current.head
        };
      });
      var t;

      var layout = function layout() {
        cancelAnimationFrame(t);
        t = requestAnimationFrame(function () {
          cloneStyles(tableRef.current.table.current, clone.current.table.current, false, 'width');
          var headHeight = tableRef.current.head.current.clientHeight;
          tableRef.current.table.current.style.marginTop = "-".concat(headHeight, "px");
          scrollContainer.current.style.top = "".concat(headHeight, "px");
          scrollContainer.current.style.height = "calc(100% - ".concat(headHeight, "px)");
          cloneStyles(tableRef.current.head.current, clone.current.head.current, true, 'width', 'th');
        });
      };

      useLayoutEffect(function () {
        layout();
        return function () {
          cancelAnimationFrame(t);
        };
      }, []);
      return React.createElement(Context.Provider, {
        value: {
          layout: layout
        }
      }, React.createElement("div", {
        style: {
          position: 'relative'
        },
        className: "scrollable-table ".concat(props.className || '')
      }, React.createElement("div", {
        className: "scrollable-table-content",
        ref: scrollContainer,
        onScroll: onScroll
      }, React.createElement("div", {
        className: "scrollable-table-wrapper"
      }, React.createElement("div", {
        className: "table-wrapper"
      }, React.createElement(Table, _extends({
        data: data,
        ref: tableRef
      }, props), children)))), React.createElement("div", {
        className: "scrollable-table-wrapper",
        style: {
          position: 'absolute',
          top: 0
        }
      }, React.createElement(FakeTable, _extends({
        ref: clone
      }, props)))));
    });
  };
};
/**
 * Wrapper
 * 
 * @param {*} param
 */


var HeaderCellOverflowWrapper = function HeaderCellOverflowWrapper(_ref) {
  var children = _ref.children;
  return React.createElement("div", {
    className: "header-wrapper"
  }, React.createElement("div", {
    className: "header-positioner"
  }, React.createElement("div", null, children)));
};

var OverflowContext = React.createContext({
  removeOverflowWrapper: false
});
/**
 * Table headerCellRenderer decorator HoC.
 * Removes removeOverflowWrapper property and stores it on context.
 * 
 * @param {*} Cell 
 */

var decorateHeaderCellRenderer$1 = function decorateHeaderCellRenderer() {
  var Cell = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DefaultHeaderCellRenderer;
  return forwardRef(function (_ref2, ref) {
    var removeOverflowWrapper = _ref2.removeOverflowWrapper,
        _ref2$style = _ref2.style,
        style = _ref2$style === void 0 ? {} : _ref2$style,
        props = _objectWithoutProperties(_ref2, ["removeOverflowWrapper", "style"]);

    return React.createElement(OverflowContext.Provider, {
      value: {
        removeOverflowWrapper: removeOverflowWrapper
      }
    }, React.createElement(Cell, _extends({
      ref: ref,
      style: _objectSpread2({}, style, {
        position: 'relative'
      })
    }, props)));
  });
};
/**
 * Table headerCellContentRenderer decorator HoC.
 * 
 * @param {*} Cell 
 */


var decorateHeaderCellContentRenderer = function decorateHeaderCellContentRenderer() {
  var Cell = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DefaultHeaderCellContentRenderer;
  return forwardRef(function (props, ref) {
    var _useContext = useContext(OverflowContext),
        removeOverflowWrapper = _useContext.removeOverflowWrapper;

    return removeOverflowWrapper ? React.createElement(Cell, _extends({
      ref: ref
    }, props)) : React.createElement(HeaderCellOverflowWrapper, null, React.createElement(Cell, _extends({
      ref: ref
    }, props)));
  });
};

var withHeaderCellOverflow = function withHeaderCellOverflow() {
  var tableFactory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : table;
  return function () {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        headerCellContentRenderer = _ref3.headerCellContentRenderer,
        headerCellRenderer = _ref3.headerCellRenderer,
        props = _objectWithoutProperties(_ref3, ["headerCellContentRenderer", "headerCellRenderer"]);

    return tableFactory(_objectSpread2({
      headerCellContentRenderer: decorateHeaderCellContentRenderer(headerCellContentRenderer),
      headerCellRenderer: decorateHeaderCellRenderer$1(headerCellRenderer)
    }, props));
  };
};

var Controll = function Controll() {
  return null;
};
/**
 * Table cellRenderer decorator HoC.
 * Ads 1 to colSpan of a previous column.
 * 
 * @param {*} Cell 
 */


var decorateCellRenderer = function decorateCellRenderer() {
  var Cell = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DefaultCellRenderer;
  return forwardRef(function (_ref, ref) {
    var colSpan = _ref.colSpan,
        props = _objectWithoutProperties(_ref, ["colSpan"]);

    var columns = props.columns,
        index = props.index;

    if (columns == null || index == null || columns[index] == null) {
      return React.createElement(Cell, _extends({
        ref: ref,
        colSpan: colSpan
      }, props));
    }

    if (columns[index].control) return null;
    return React.createElement(Cell, _extends({
      ref: ref,
      colSpan: index + 1 < columns.length && columns[index + 1].control ? (colSpan || 1) + 1 : colSpan
    }, props));
  });
};
/**
 * Table headerCellRenderer decorator HoC.
 * Removes control property.
 * 
 * @param {*} Cell 
 */


var decorateHeaderCellRenderer$2 = function decorateHeaderCellRenderer() {
  var Cell = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DefaultHeaderCellRenderer;
  return forwardRef(function (_ref2, ref) {
    var control = _ref2.control,
        props = _objectWithoutProperties(_ref2, ["control"]);

    return React.createElement(Cell, _extends({
      ref: ref
    }, props));
  });
};

var withHeaderControl = function withHeaderControl() {
  var tableFactory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : table;
  return function () {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        cellRenderer = _ref3.cellRenderer,
        headerCellRenderer = _ref3.headerCellRenderer,
        options = _objectWithoutProperties(_ref3, ["cellRenderer", "headerCellRenderer"]);

    var Table = tableFactory(_objectSpread2({
      cellRenderer: decorateCellRenderer(cellRenderer),
      headerCellRenderer: decorateHeaderCellRenderer$2(headerCellRenderer)
    }, options));
    return Table;
  };
};

var efn = function efn() {};

var defaultState = {
  remove: efn,
  add: efn,
  toggle: efn,
  isSelected: efn
};
var SelectionContext = React.createContext(defaultState);
/**
 * A factory to generate selection reducer.
 * 
 * @param {*} add - Format (state, value) => []. Factory method to create a new state.
 */

var selectionReducerFactory = function selectionReducerFactory(add) {
  return function (state, action) {
    switch (action.type) {
      case 'clear':
        return [];

      case 'add':
        return add(state, action.value);

      case 'remove':
        return state.filter(function (i) {
          return i !== action.value;
        });

      case 'toggle':
        return state.indexOf(action.value) >= 0 ? state.filter(function (i) {
          return i !== action.value;
        }) : add(state, action.value);

      default:
        return state;
    }
  };
};

var multiSelectionReducer = selectionReducerFactory(function (state, value) {
  return value != null ? state.concat(value) : state;
});
var singleSelectionReducer = selectionReducerFactory(function (state, value) {
  return value != null ? [value] : state;
});
/**
 * Generates selection context using provided selectionReducer.
 * This module contains multiSelection and singleSelection reducers.
 * 
 * @param {*} selectionReducer - user one of provided reducers,
 *            should implement add, remove, toggle and clear action types.
 * @param {*} Component - wrapped component
 */

var selectionContext = function selectionContext() {
  var selectionReducer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : singeSelectionReducer;
  var Component = arguments.length > 1 ? arguments[1] : undefined;
  return forwardRef(function (_ref, ref) {
    var _ref$onSelection = _ref.onSelection,
        onSelection = _ref$onSelection === void 0 ? efn : _ref$onSelection,
        props = _objectWithoutProperties(_ref, ["onSelection"]);

    var _useReducer = useReducer(selectionReducer, []),
        _useReducer2 = _slicedToArray(_useReducer, 2),
        selected = _useReducer2[0],
        dispatch = _useReducer2[1];

    var isSelected = function isSelected(value) {
      return selected.indexOf(value) >= 0;
    }; // dirty


    var mounted = useRef();
    useEffect(function () {
      if (!mounted.current) {
        mounted.current = true;
      } else {
        onSelection(selected);
      }
    }, [selected]);

    var add = function add(value) {
      return dispatch({
        type: 'add',
        value: value
      });
    };

    var toggle = function toggle(value) {
      return dispatch({
        type: 'toggle',
        value: value
      });
    };

    var remove = function remove(value) {
      return dispatch({
        type: 'remove',
        value: value
      });
    };

    var clear = function clear() {
      return dispatch({
        type: 'clear'
      });
    };

    return React.createElement(SelectionContext.Provider, {
      value: {
        remove: remove,
        toggle: toggle,
        isSelected: isSelected,
        add: add,
        clear: clear,
        selected: selected
      }
    }, React.createElement(Component, _extends({}, props, {
      ref: ref
    })));
  });
};
/**
 * Table dataRowRenderer decorator HoC.
 * 
 * @param {*} Row - rowRenderer
 * @param {*} DataRow - dataRowRenderer
 */


var detailsRowRenderer = function detailsRowRenderer() {
  var DataRow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DefaultDataRowRenderer;
  var Row = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DefaultRowRenderer;

  var RowWithDetals = function RowWithDetals(_ref) {
    var className = _ref.className,
        tableProps = _ref.tableProps,
        props = _objectWithoutProperties(_ref, ["className", "tableProps"]);

    var _useContext = useContext(DetailsContext),
        _close = _useContext.close,
        toggle = _useContext.toggle,
        isSelected = _useContext.isSelected,
        Details = _useContext.detailsRenderer,
        tabIndex = _useContext.tabIndex,
        _useContext$isSelecta = _useContext.isSelectable,
        isSelectable = _useContext$isSelecta === void 0 ? function (index) {
      return true;
    } : _useContext$isSelecta;

    if (Details == null) {
      return React.createElement(DataRow, _objectSpread2({
        className: className,
        tableProps: tableProps
      }, props));
    }

    var index = props.index,
        columns = props.columns;

    var onClick = function onClick() {
      return toggle(index);
    };

    var selected = isSelected(index);
    var selectable = isSelectable(index);
    var classNames = [];
    if (className) classNames.push(className);
    if (selectable) classNames.push('selectable-row');
    if (selected) classNames.push('selected-row');
    return React.createElement(React.Fragment, null, React.createElement(DataRow, _extends({}, props, {
      tableProps: tableProps,
      tabIndex: onClick && tabIndex ? tabIndex : undefined,
      onKeyPress: selectable ? function (e) {
        if (e.which === 13 && e.target.click) e.target.click();
      } : undefined,
      onClick: selectable ? onClick : undefined,
      className: classNames.length > 0 ? classNames.join(' ') : undefined
    })), selected ? React.createElement(Row, {
      className: "inline-details"
    }, React.createElement("td", {
      colSpan: columns.length
    }, React.createElement(Details, _extends({}, props, tableProps, {
      close: function close() {
        return _close(index);
      }
    })))) : null);
  };

  return RowWithDetals;
};

var DetailsContext = React.createContext({
  detailsRenderer: function detailsRenderer() {
    return null;
  },
  close: function close(index) {},
  toggle: function toggle(index) {},
  open: function open(index) {},
  isSelected: function isSelected(index) {
    return true;
  },
  clear: function clear() {},
  isSelectable: function isSelectable(index) {
    return true;
  },
  selected: [],
  tabIndex: undefined,
  keyFactory: function keyFactory(index) {
    return true;
  }
});
/**
 * HoC that injects DetailsContext into a Table.
 * Utilizes SelectionContext.
 * 
 * Injects the context.
 * Overrides row renderer to inject details into the table.
 * Overrides tabIndex, onClick and onKeyPress from table dataRowProps attribute.
 * 
 * @param {*} selectionReducer -- a reducer used by SelectionContext. 
 */

var withInlineDetailsContext = function withInlineDetailsContext() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$selectionReduce = _ref2.selectionReducer,
      selectionReducer = _ref2$selectionReduce === void 0 ? singleSelectionReducer : _ref2$selectionReduce,
      tabIndex = _ref2.tabIndex,
      _ref2$clearOnDataChan = _ref2.clearOnDataChange,
      clearOnDataChange = _ref2$clearOnDataChan === void 0 ? true : _ref2$clearOnDataChan,
      _ref2$isSelectable = _ref2.isSelectable,
      _isSelectable = _ref2$isSelectable === void 0 ? function (data, index) {
    return true;
  } : _ref2$isSelectable,
      _ref2$keyFactory = _ref2.keyFactory,
      keyFactory = _ref2$keyFactory === void 0 ? function (data, index) {
    return index;
  } : _ref2$keyFactory;

  return function () {
    var tableFactory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : table;
    return function () {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          dataRowRenderer = _ref3.dataRowRenderer,
          rowRenderer = _ref3.rowRenderer,
          options = _objectWithoutProperties(_ref3, ["dataRowRenderer", "rowRenderer"]);

      var Table = tableFactory(_objectSpread2({
        dataRowRenderer: detailsRowRenderer(dataRowRenderer, rowRenderer),
        rowRenderer: rowRenderer
      }, options));
      return selectionContext(selectionReducer, forwardRef(function (_ref4, ref) {
        var data = _ref4.data,
            detailsRenderer = _ref4.detailsRenderer,
            props = _objectWithoutProperties(_ref4, ["data", "detailsRenderer"]);

        var selection = useContext(SelectionContext); // dirty

        var mounted = useRef();
        useEffect(function () {
          if (!mounted.current) {
            mounted.current = true;
          } else {
            if (clearOnDataChange) {
              selection.clear();
            }
          }
        }, [data]);
        return React.createElement(DetailsContext.Provider, {
          value: {
            close: function close(index) {
              selection.remove(keyFactory(data, index));
            },
            toggle: function toggle(index) {
              selection.toggle(keyFactory(data, index));
            },
            isSelected: function isSelected(index) {
              return selection.isSelected(keyFactory(data, index));
            },
            open: function open(index) {
              return selection.add(keyFactory(data, index));
            },
            clear: selection.clear,
            detailsRenderer: detailsRenderer,
            isSelectable: function isSelectable(index) {
              return _isSelectable(data, index);
            },
            tabIndex: tabIndex,
            keyFactory: keyFactory,
            selected: selection.selected
          }
        }, React.createElement(Table, _extends({
          ref: ref,
          data: data
        }, props)));
      }));
    };
  };
};

var is = {
  fn: function fn(v) {
    return typeof v === "function";
  },
  string: function string(v) {
    return typeof v === "string";
  }
};
/**
 * HoC for adding Loading Component as a last child of a Table
 * if fetching is truthy and calling fetch when the table in scrolled to bottom
 * and fetching is falsy.
 *
 * @param {*} Loading
 */

var withLazyLoading = function withLazyLoading() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$Loading = _ref.Loading,
      Loading = _ref$Loading === void 0 ? function () {
    return "Loading";
  } : _ref$Loading,
      NoDataComponent = _ref.NoDataComponent,
      _ref$threshold = _ref.threshold,
      threshold = _ref$threshold === void 0 ? 50 : _ref$threshold;

  return function () {
    var tableFactory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : table;
    return function (options) {
      var Table = tableFactory(options);
      return forwardRef(function (_ref2, outerRef) {
        var fetch = _ref2.fetch,
            _ref2$fetching = _ref2.fetching,
            fetching = _ref2$fetching === void 0 ? false : _ref2$fetching,
            _ref2$fetchable = _ref2.fetchable,
            fetchable = _ref2$fetchable === void 0 ? true : _ref2$fetchable,
            children = _ref2.children,
            data = _ref2.data,
            props = _objectWithoutProperties(_ref2, ["fetch", "fetching", "fetchable", "children", "data"]);

        var tableRef = useRef();
        useImperativeHandle(outerRef, function () {
          return tableRef.current;
        });
        var ref = useRef();
        useImperativeHandle(ref, function () {
          return tableRef.current.scrollContainer;
        });
        useEffect(function () {
          var shouldFetch = !fetching && fetchable && is.fn(fetch);

          function listener(e) {
            var _e$target = e.target,
                scrollHeight = _e$target.scrollHeight,
                scrollTop = _e$target.scrollTop,
                clientHeight = _e$target.clientHeight;

            if (scrollTop + clientHeight + threshold >= scrollHeight) {
              if (shouldFetch) {
                e.target.removeEventListener("scroll", listener);
                fetch();
              }
            }
          }

          var node = ref && ref.current;

          if (shouldFetch && node && node.addEventListener) {
            node.addEventListener("scroll", listener);
          }

          return function () {
            if (node && node.removeEventListener) {
              node.removeEventListener("scroll", listener);
            }
          };
        });
        var Component = null;

        if (fetching) {
          Component = Loading;
        } else if (!fetchable && (data == null || data.length === 0)) {
          Component = NoDataComponent;
        }

        return React.createElement(Table, _extends({
          ref: tableRef,
          data: data
        }, props), children, Component != null ? React.createElement(Component, null) : null);
      });
    };
  };
};
/**
 * returns a new sorting order based on current sorting order
 */


var sortOrderFactory = function sortOrderFactory() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      parameter = _ref.parameter,
      direction = _ref.direction,
      _ref$defaultDirection = _ref.defaultDirection,
      defaultDirection = _ref$defaultDirection === void 0 ? "asc" : _ref$defaultDirection;

  return function (name) {
    return {
      parameter: name,
      direction: name !== parameter ? defaultDirection : direction.toLowerCase() === "asc" ? "desc" : "asc"
    };
  };
};
/**
 * returns a single parameter from list of names
 * if one of names is a sorting parameter then it will be returned
 * otherwise the first element in names will be returned
 */


var sortParameterFactory = function sortParameterFactory() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      parameter = _ref2.parameter;

  return function () {
    for (var _len = arguments.length, names = new Array(_len), _key = 0; _key < _len; _key++) {
      names[_key] = arguments[_key];
    }

    if (names.indexOf(parameter) >= 0) return parameter;
    return names[0];
  };
};

var SortableContext = React.createContext({
  sortOrder: {},
  data: [],
  sortedData: [],
  sort: function sort() {}
});
/**
 * Simple wrapper to inject sorting on click
 * //FIXME overrides onClick
 */

var Sorter = function Sorter(_ref3) {
  var name = _ref3.name,
      _ref3$disabled = _ref3.disabled,
      disabled = _ref3$disabled === void 0 ? false : _ref3$disabled,
      _ref3$Component = _ref3.Component,
      Component = _ref3$Component === void 0 ? "span" : _ref3$Component,
      className = _ref3.className,
      props = _objectWithoutProperties(_ref3, ["name", "disabled", "Component", "className"]);

  var _useContext = useContext(SortableContext),
      sortOrder = _useContext.sortOrder,
      sort = _useContext.sort;

  var classNames = [];
  if (className) classNames.push(className);

  if (!disabled) {
    classNames.push("sorter");
    var parameter = sortOrder.parameter;
    if (name === parameter) classNames.push("sorted");
  }

  return React.createElement(Component, _extends({
    className: classNames.length > 0 ? classNames.join(" ") : undefined,
    onClick: disabled ? undefined : function (e) {
      e.stopPropagation();
      sort(name);
    }
  }, props));
};
/**
 *
 * @param {*} parameter
 * @param {*} direction
 */


var defaultSortFactory = function defaultSortFactory(parameter, direction) {
  return function (a, b) {
    var m = direction === "asc" ? 1 : -1;
    var result;

    if (is.string(a[parameter])) {
      result = (a[parameter] || "").toUpperCase() >= (b[parameter] || "").toUpperCase();
    } else {
      result = a[parameter] >= b[parameter];
    }

    return (result ? 1 : -1) * m;
  };
};
/**
 * HoC to create sortable context.
 * Based on react hooks.
 *
 * Wrapper recieves 'data' prop, sorts it
 * and returns sorted data as 'data' prop to the Component.
 *
 * @param {*} Component
 * @param {*} options - {
 *  sortFactory - (parameter, direction) => (a, b) => number,
 *  parameter - default sort parameter
 *  direction - default sort direction
 *  defaultDirection - a direction that is used when the sort parameter changes
 * }
 */


var controlledSortableContext = function controlledSortableContext(Component) {
  var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref4$sortFactory = _ref4.sortFactory,
      sortFactory = _ref4$sortFactory === void 0 ? defaultSortFactory : _ref4$sortFactory,
      _ref4$defaultDirectio = _ref4.defaultDirection,
      defaultDirection = _ref4$defaultDirectio === void 0 ? "asc" : _ref4$defaultDirectio,
      _ref4$inMemory = _ref4.inMemory,
      inMemory = _ref4$inMemory === void 0 ? true : _ref4$inMemory;

  return forwardRef(function (_ref5, ref) {
    var _ref5$data = _ref5.data,
        data = _ref5$data === void 0 ? [] : _ref5$data,
        onSort = _ref5.onSort,
        _ref5$sortDirection = _ref5.sortDirection,
        sortDirection = _ref5$sortDirection === void 0 ? "asc" : _ref5$sortDirection,
        sortParameter = _ref5.sortParameter,
        props = _objectWithoutProperties(_ref5, ["data", "onSort", "sortDirection", "sortParameter"]);

    var sortedData = !inMemory ? data : useMemo(function () {
      var sortedData = sortParameter == null ? data : data.sort(sortFactory(sortParameter, sortDirection));
      return sortedData.slice();
    }, [data, sortParameter, sortDirection]);
    var sortOrder = useMemo(function () {
      return {
        parameter: sortParameter,
        direction: sortDirection,
        defaultDirection: defaultDirection
      };
    }, [sortParameter, sortDirection]);

    var sort = function sort(name) {
      var _sortOrderFactory = sortOrderFactory(sortOrder)(name),
          parameter = _sortOrderFactory.parameter,
          direction = _sortOrderFactory.direction;

      is.fn(onSort) && onSort({
        parameter: parameter,
        direction: direction
      });
    };

    return React.createElement(SortableContext.Provider, {
      value: {
        sortOrder: sortOrder,
        data: data,
        sortedData: sortedData,
        sort: sort
      }
    }, React.createElement(Component, _extends({}, props, {
      data: sortedData,
      ref: ref
    })));
  });
};
/**
 * A HoC for generating wrapper around controlledSortableContext
 * that stores the state.
 *
 * @returns a component with
 *  defaultSortParameter
 *  defaultSortDirection
 *  onSort
 * props.
 *
 * @param {*} Component
 * @param {*} options - controlledSortableContext options
 * @see controlledSortableContext
 */


var sortableContext = function sortableContext(Component) {
  var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref6$sortFactory = _ref6.sortFactory,
      sortFactory = _ref6$sortFactory === void 0 ? defaultSortFactory : _ref6$sortFactory,
      _ref6$defaultDirectio = _ref6.defaultDirection,
      defaultDirection = _ref6$defaultDirectio === void 0 ? "asc" : _ref6$defaultDirectio,
      _ref6$inMemory = _ref6.inMemory,
      inMemory = _ref6$inMemory === void 0 ? true : _ref6$inMemory;

  var Sortable = controlledSortableContext(Component, {
    sortFactory: sortFactory,
    defaultDirection: defaultDirection,
    inMemory: inMemory
  });
  return forwardRef(function (_ref7, ref) {
    var onSort = _ref7.onSort,
        defaultSortParameter = _ref7.defaultSortParameter,
        _ref7$defaultSortDire = _ref7.defaultSortDirection,
        defaultSortDirection = _ref7$defaultSortDire === void 0 ? "asc" : _ref7$defaultSortDire,
        props = _objectWithoutProperties(_ref7, ["onSort", "defaultSortParameter", "defaultSortDirection"]);

    var _useState = useState({
      parameter: defaultSortParameter,
      direction: defaultSortDirection
    }),
        _useState2 = _slicedToArray(_useState, 2),
        state = _useState2[0],
        changeState = _useState2[1];

    var sort = function sort(_ref8) {
      var parameter = _ref8.parameter,
          direction = _ref8.direction;
      changeState({
        parameter: parameter,
        direction: direction
      });

      if (is.fn(onSort)) {
        onSort({
          parameter: parameter,
          direction: direction
        });
      }
    };

    return React.createElement(Sortable, _extends({
      ref: ref,
      sortParameter: state.parameter,
      sortDirection: state.direction,
      onSort: sort
    }, props));
  });
};
/**
 * Table headerCellRenderer decorator HoC.
 * 
 * @param {*} Cell - headerCellRenderer
 */


var sortableHeaderCellRenderer = function sortableHeaderCellRenderer() {
  var Cell = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DefaultHeaderCellRenderer;
  return forwardRef(function (_ref, ref) {
    var className = _ref.className,
        sortable = _ref.sortable,
        name = _ref.name,
        props = _objectWithoutProperties(_ref, ["className", "sortable", "name"]);

    var _useContext = useContext(SortableContext),
        sortOrder = _useContext.sortOrder,
        sort = _useContext.sort;

    var parameter = sortOrder.parameter,
        direction = sortOrder.direction;
    var classNames = [];
    if (className) classNames.push(className);
    if (sortable && name != null) classNames.push('sortable-column');

    if (name != null && name === parameter) {
      classNames.push("sorted-".concat(direction.toLowerCase()));
    }

    return React.createElement(Cell, _extends({
      ref: ref,
      className: classNames.length > 0 ? classNames.join(' ') : undefined,
      onClick: sortable ? function () {
        return sort(name);
      } : undefined,
      name: name
    }, props));
  });
};
/**
 * Table headerCellContentRenderer decorator HoC.
 * 
 * @param {*} Cell 
 */


var addSortIcon = function addSortIcon() {
  var Cell = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DefaultHeaderCellContentRenderer;
  return forwardRef(function (_ref2, ref) {
    var children = _ref2.children,
        props = _objectWithoutProperties(_ref2, ["children"]);

    return React.createElement(Cell, _extends({
      ref: ref
    }, props), children, React.createElement("div", {
      className: "sort-image"
    }));
  });
};
/**
 * Overloaded method for sortableTable with inMemory flag set to true.
 * 
 * Sets
 *  inMemory to true
 *  sortableContextHoc to sortableContext 
 * 
 * @param {*} tableFactory 
 * @param {*} sortParams - options for sortableTable
 * 
 * @see sortableTable
 * @see sortableContext
 */


var withInMemorySortingContext = function withInMemorySortingContext() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      inMemory = _ref3.inMemory,
      sortableContextHoc = _ref3.sortableContextHoc,
      props = _objectWithoutProperties(_ref3, ["inMemory", "sortableContextHoc"]);

  return withSortingContext(_objectSpread2({
    inMemory: true,
    sortableContextHoc: sortableContext
  }, props));
};
/**
 * HoC factory that injects sortableContext into a Table.
 * 
 * Defaults are
 *  inMemory = false
 *  sortableContextHoc = controlledSortableContext
 * 
 * Wraps the Table with sortableContext.
 * Modifies column name (in case of a list).
 * Overrides header renderer to inject sorting into header.
 * 
 * @param {*} tableFactory
 * @param {*} options
 * 
 * @see sortableContext
 * @see controlledSortableContext
 */


var withSortingContext = function withSortingContext(_ref4) {
  var defaultDirection = _ref4.defaultDirection,
      sortFactory = _ref4.sortFactory,
      _ref4$inMemory = _ref4.inMemory,
      inMemory = _ref4$inMemory === void 0 ? false : _ref4$inMemory,
      _ref4$sortableContext = _ref4.sortableContextHoc,
      sortableContextHoc = _ref4$sortableContext === void 0 ? controlledSortableContext : _ref4$sortableContext;
  return function () {
    var tableFactory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : table;
    return function () {
      var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref5$headerCellRende = _ref5.headerCellRenderer,
          headerCellRenderer = _ref5$headerCellRende === void 0 ? DefaultHeaderCellRenderer : _ref5$headerCellRende,
          _ref5$headerCellConte = _ref5.headerCellContentRenderer,
          headerCellContentRenderer = _ref5$headerCellConte === void 0 ? DefaultHeaderCellContentRenderer : _ref5$headerCellConte,
          props = _objectWithoutProperties(_ref5, ["headerCellRenderer", "headerCellContentRenderer"]);

      var Table = tableFactory(_objectSpread2({
        headerCellRenderer: sortableHeaderCellRenderer(headerCellRenderer),
        headerCellContentRenderer: addSortIcon(headerCellContentRenderer)
      }, props));
      return sortableContextHoc(forwardRef(function (_ref6, ref) {
        var _ref6$columns = _ref6.columns,
            columns = _ref6$columns === void 0 ? [] : _ref6$columns,
            props = _objectWithoutProperties(_ref6, ["columns"]);

        var _useContext2 = useContext(SortableContext),
            sortOrder = _useContext2.sortOrder;

        return React.createElement(Table, _extends({
          ref: ref,
          columns: columns.map(function (_ref7) {
            var names = _ref7.name,
                props = _objectWithoutProperties(_ref7, ["name"]);

            var name = Array.isArray(names) ? sortParameterFactory(sortOrder).apply(void 0, _toConsumableArray(names)) : names;
            return _objectSpread2({
              name: name
            }, props);
          })
        }, props));
      }), {
        defaultDirection: defaultDirection,
        sortFactory: sortFactory,
        inMemory: inMemory
      });
    };
  };
};

var ClickableRowContext = React.createContext({
  onClick: function onClick() {},
  isClickable: function isClickable(index) {
    return true;
  }
});
/**
 * Table dataRowRenderer decorator HoC.
 * 
 * @param {*} DataRow - dataRowRenderer
 */

var clickableRow = function clickableRow() {
  var DataRow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DefaultDataRowRenderer;
  return React.forwardRef(function (_ref, ref) {
    var onClickDefault = _ref.onClick,
        tabIndexDefault = _ref.tabIndex,
        style = _ref.style,
        className = _ref.className,
        props = _objectWithoutProperties(_ref, ["onClick", "tabIndex", "style", "className"]);

    var _React$useContext = React.useContext(ClickableRowContext),
        onClick = _React$useContext.onClick,
        isClickable = _React$useContext.isClickable,
        tabIndex = _React$useContext.tabIndex;

    var clickable = React.useMemo(function () {
      return onClick && isClickable(props.index);
    }, [props.data, props.index, isClickable, onClick]);
    var classNames = [];
    if (className) classNames.push(className);
    if (clickable) classNames.push('clickable-row');
    return React.createElement(DataRow, _extends({}, props, {
      ref: ref,
      tabIndex: tabIndex != null ? tabIndex : tabIndexDefault,
      onClick: clickable ? function (e) {
        onClick(props.index, e);
      } : undefined,
      style: !clickable ? style : _objectSpread2({}, style || {}, {
        cursor: 'pointer'
      }),
      className: classNames.length > 0 ? classNames.join(' ') : undefined
    }));
  });
};
/**
 * HoC that injects ClickableRowContext into a Table.
 * 
 * Injects the context.
 * Overrides data row renderer to inject onClick into the table data row.
 * Adds tabIndex from config.
 * Overrides onClick from table onRowClick attribute.
 * 
 * @param {*} isClickable - fn to check if row is clickable
 * @param {*} tabIndex - data row tabIndex if necessary
 */


var withClickableRowContext = function withClickableRowContext() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      tabIndex = _ref2.tabIndex,
      _ref2$isClickable = _ref2.isClickable,
      isClickable = _ref2$isClickable === void 0 ? function (index) {
    return true;
  } : _ref2$isClickable;

  return function () {
    var tableFactory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : table;
    return function () {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          dataRowRenderer = _ref3.dataRowRenderer,
          options = _objectWithoutProperties(_ref3, ["dataRowRenderer"]);

      var Table = tableFactory(_objectSpread2({
        dataRowRenderer: clickableRow(dataRowRenderer)
      }, options));
      var ClickableRowTable = React.forwardRef(function (_ref4, ref) {
        var onRowClick = _ref4.onRowClick,
            props = _objectWithoutProperties(_ref4, ["onRowClick"]);

        return React.createElement(ClickableRowContext.Provider, {
          value: {
            onClick: onRowClick,
            tabIndex: tabIndex,
            isClickable: isClickable
          }
        }, React.createElement(Table, _extends({
          ref: ref
        }, props)));
      });
      return ClickableRowTable;
    };
  };
};

export { AdaptiveContext, Controll, DefaultAdaptiveComponent, DefaultCellRenderer, DefaultDataCellRenderer, DefaultDataRowRenderer, DefaultHeaderCellContentRenderer, DefaultHeaderCellRenderer, DefaultHeaderRenderer, DefaultRowRenderer, DetailsContext, EmptyRowContext, HeaderCellOverflowWrapper, ResizeTrigger, SelectionContext, SortableContext, Sorter, composeDecorators, controlledSortableContext, defaultState, multiSelectionReducer, selectionContext, selectionReducerFactory, singleSelectionReducer, sortOrderFactory, sortParameterFactory, sortableContext, table, withAdaptive, withClickableRowContext, withEmptyRow, withFixedHeader, withHeaderCellOverflow, withHeaderControl, withInMemorySortingContext, withInlineDetailsContext, withLazyLoading, withSortingContext };